// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import {
    filterCollection,
    sortCollection
} from '../../../shared/services/collections';
import {
    getDealerInvoiceClaimsFilterOptions,
    getDealerInvoiceClaimsSortOptions
} from '../services/dealer-invoice-helper';
import DealerInvoiceFacets from './dealer-invoice-facets';
import DealerInvoiceHeader from './dealer-invoice-header';
import DealerInvoiceList from './dealer-invoice-list';
import Facets from '../state/facets';
import Invoice from '@deere/cps-it.warranty-model-factory/lib/invoice';
import LaborRateLinkPanel from '../../shared/components/labor-rate-link-panel';
import RefinableListWidgetWithExport from '../../../shared/components/refinable-list-widget/refinable-list-widget-with-export';
import SearchBox from './dealer-invoice-search-box';
import SearchFilters from '../state/search-filters';
import State from '../state';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {getSelectedDisplayedDealers} from '../../../shared/services/facets';

function handleDownloadToExcel() {

    const selectedDisplayedDealers = getSelectedDisplayedDealers(this.facets.dealerAccountsFacet);

    this.actions.exportToExcel(selectedDisplayedDealers, this.user.getLocale());

}

function handleDetailsButtonClick(invoice) {

    this.actions.updateInvoiceToComplete(invoice);

}

const loadAllDealers = dealerAccountsFacet =>
    dealerAccountsFacet.isInitialLoad || dealerAccountsFacet.selectedDealers.length === 0;

class DealerInvoices extends Component {

    componentWillMount() {

        if (loadAllDealers(this.props.facets.dealerAccountsFacet)) {

            this.props.actions.selectAllDealersOnInitialLoad(this.props.facets.dealerAccountsFacet.allowedDealers);

        }

        this.props.actions.readDealerInvoices(true);

        if (!this.props.allClaimsCount) {

            this.props.actions.readAllClaims(true, true);

        }

    }

    render() {

        let sortedCollection;

        sortedCollection = [...this.props.dealerInvoices];
        sortedCollection = sortCollection(this.props.searchFilters.sortBy, this.props.searchFilters.sortDirection, sortedCollection);
        sortedCollection = filterCollection(this.props.searchFilters.filterBy, getDealerInvoiceClaimsFilterOptions(), sortedCollection);

        return (
            <section className='dealer-invoices'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <aside className='dealer-invoice-aside'>
                    <DealerInvoiceFacets/>
                    <LaborRateLinkPanel/>
                </aside>
                <main className='dealer-invoice-main'>
                    <SearchBox/>
                    <DealerInvoiceHeader
                        allClaimsCount={this.props.allClaimsCount}
                        claimSearchCount={this.props.claimSearchCount}
                        dealerInvoiceCount={this.props.dealerInvoices.length}
                        hasSearchResults={this.props.hasSearchResults}
                    />
                    <section className='dealer-invoice-results'>
                        <RefinableListWidgetWithExport
                            hasResults={this.props.dealerInvoices.length > 0}
                            onExport={this.props::handleDownloadToExcel}
                            onFilterByChange={this.props.actions.updateListFilterBy}
                            onSortByChange={this.props.actions.updateListSortBy}
                            onSortDirectionChange={this.props.actions.updateListSortDirection}
                            searchFilters={this.props.searchFilters}
                            sortOptions={getDealerInvoiceClaimsSortOptions()}
                            type={State}
                        />
                        <DealerInvoiceList
                            busyCounter={this.props.busyCounter}
                            invoices={sortedCollection}
                            onDetailsButtonClick={this.props::handleDetailsButtonClick}
                            user={this.props.user}
                        />
                    </section>
                </main>
            </section>
        );

    }

}

DealerInvoices.displayName = 'DealerInvoices';
DealerInvoices.propTypes = {
    actions: PropTypes.object.isRequired,
    allClaimsCount: PropTypes.number.isRequired,
    busyCounter: PropTypes.number.isRequired,
    claimSearchCount: PropTypes.number.isRequired,
    dealerInvoices: PropTypes.arrayOf(PropTypes.instanceOf(Invoice)).isRequired,
    facets: PropTypes.instanceOf(Facets).isRequired,
    hasSearchResults: PropTypes.bool.isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default DealerInvoices;



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/components/index.js